import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Box, Button, SxProps, Theme, Typography } from '@mui/material';

const STRINGS = appStrings.modules.satActBooster.loadError;

type BoosterInlineErrorProps = Readonly<{
  id: string;
  /** Overrides the default body copy where a surface needs to name what failed. */
  message?: string;
  onRetry: () => void;
}>;

/**
 * Compact failure state with a retry, for surfaces rendered inside a panel or card where the
 * full-page error would not fit. Keeps a failed fetch visually distinct from an empty result.
 */
export const BoosterInlineError = ({ id, message, onRetry }: BoosterInlineErrorProps) => (
  <Box sx={rootSx} id={id}>
    <Typography variant="text-sm-regular" sx={bodySx}>
      {message ?? STRINGS.body}
    </Typography>
    <Button id={`${id}-retry`} variant="outlined" size="sm" onClick={onRetry}>
      {STRINGS.retry}
    </Button>
  </Box>
);

const rootSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: backrs.spacing['spacing-md'],
  padding: backrs.spacing['spacing-xl'],
});

const bodySx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-secondary'],
});
